import React, { useEffect, useState } from "react";
import PaymentVoucherTemplate from "../VoucherTemplate/PaymentVoucherTemplate";
import api from "../api/axios";
import { useParams } from "react-router-dom";

const PaymentVoucherPage = () => {
  const { id } = useParams();
  const [voucher, setVoucher] = useState(null);

  useEffect(() => {
    api.get(`payment_vouchers/${id}`)
      .then(res => setVoucher(res.data));
  }, [id]);

  return (
    <div>
      <PaymentVoucherTemplate voucher={voucher} />
    </div>
  );
};

export default PaymentVoucherPage;
